<template>
   
  <div>
    <el-dialog
      top="10vh"
      width="800px"
      center
      :title="isEdit ? '创建' : '修改'"
      :visible.sync="dialogVisible"
      @close="HandleCancel"
    >
      <el-form :rules="rules" :model="editData" :ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="isEdit" prop="smsReceipt" label="短信凭证">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.smsReceipt"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="isEdit"
              prop="transdetailReceipt"
              label="银行流水凭证"
            >
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.transdetailReceipt"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="isEdit" prop="tansdetail" label="账单凭证">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.tansdetail"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bankNo" label="银行卡卡号">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model.trim="editData.bankNo"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="amount" label="金额">
              <el-form-item>
                <el-input-number
                  style="width: 230px"
                  v-model="editData.amount"
                  :min="0"
                >
                </el-input-number>
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transPayBankNo" label="付款方卡号">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.transPayBankNo"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transPayName" label="付款方姓名">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.transPayName"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transPayeeBankNo" label="收款方卡号">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.transPayeeBankNo"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transPayeeName" label="收款方姓名">
              <el-form-item>
                <el-input
                  style="width: 230px"
                  clearable
                  v-model="editData.transPayeeName"
                />
              </el-form-item>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="smsGetTime" label="短信取得時間">
              <el-date-picker
                style="width: 230px"
                v-model="editData.smsGetTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="smsPayedTime" label="短信支付時間">
              <el-date-picker
                style="width: 230px"
                v-model="editData.smsPayedTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transdetailGetTime" label="帐单获取时间">
              <el-date-picker
                style="width: 230px"
                v-model="editData.transdetailGetTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transPayedTime" label="帐单支付时间">
              <el-date-picker
                style="width: 230px"
                v-model="editData.transPayedTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel"> 取消 </el-button>
        <el-button :loading="loading" round type="success" @click="HandleVaild">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import {
  addWithdrawOrderReceipt,
  updateWithdrawOrderReceipt,
  addPayOrderReceipt,
  updatePayOrderReceipt,
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["certificateDialog", "orderType", "editData"],
  data() {
    return {
      form: "form",
      orderFixingDialog: false,
      orderData: {},
      loading: false,
      rules: {
        amount: [{ required: true, message: "必填项目不可为空" }],
        bankNo: [
          { required: true, message: "银行卡号格式不符", pattern: /^[0-9]+$/ },
        ],
        smsReceipt: [{ required: true, message: "必填项目不可为空" }],
        tansdetail: [{ required: true, message: "必填项目不可为空" }],
        transPayBankNo: [{ required: true, message: "必填项目不可为空" }],
        transPayName: [{ required: true, message: "必填项目不可为空" }],
        transPayeeBankNo: [{ required: true, message: "必填项目不可为空" }],
        transPayeeName: [{ required: true, message: "必填项目不可为空" }],
        transPayedTime: [{ required: true, message: "必填项目不可为空" }],
        transdetailReceipt: [{ required: true, message: "必填项目不可为空" }],
        transdetailGetTime: [{ required: true, message: "必填项目不可为空" }],
        smsPayedTime: [{ required: true, message: "必填项目不可为空" }],
        smsGetTime: [{ required: true, message: "必填项目不可为空" }],
      },
    };
  },
  computed: {
    isEdit() {
      if (
        this.editData.id &&
        this.editData.createdUserId !== this.userInfo.userId
      )
        return false;
      return true;
    },
    dialogVisible: {
      get() {
        return this.certificateDialog;
      },
      set(val) {
        this.$emit("update:certificateDialog", val);
      },
    },
  },
  methods: {
    HandleCancel() {
      this.$refs[this.form].resetFields();
      this.$emit("update:editData", {});
      this.dialogVisible = false;
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (!valid) return;
        this.loading = true;
        if (this.orderType === "pay") {
          this.HandlePaySubmit();
        } else if (this.orderType === "withdraw") {
          this.HandleWithdrawSubmit();
        }
      });
    },
    HandlePaySubmit() {
      if (!this.editData.id) {
        addPayOrderReceipt(this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      } else {
        updatePayOrderReceipt(this.editData.id, this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    HandleWithdrawSubmit() {
      if (!this.editData.id) {
        addWithdrawOrderReceipt(this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      } else {
        updateWithdrawOrderReceipt(this.editData.id, this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderCertificate.vue